import { Injectable } from '@angular/core';
import { Observable, Subscriber, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { ProductsService } from './products.service';
import { OrderLineType } from '../models/order-line-type';
import { Product } from '../models/product';
import { ProductGroup } from '../models/products-group';
import { Category } from '../models/category';


@Injectable()
export class ProductsStateService {

  private _allProducts: Map<OrderLineType, Product[]>;
  private _categories: Category[];

  constructor(
    private productsService: ProductsService,
  ) {
  }

  get giftcardProducts(): Observable<Product[]> {
    return this._getProducts(OrderLineType.GiftCard);
  }

  get customGiftCardProduct(): Observable<Product[]> {
    return this._getProducts(OrderLineType.CustomGiftCard);
  }

  get depositProducts(): Observable<Product[]> {
    return this._getProducts(OrderLineType.Deposits);
  }

  get products(): Observable<Product[]> {
    return this._getProducts(OrderLineType.Product);
  }

  get categories(): Observable<Category[]> {
    return of(true).pipe(
      switchMap(_ => {
        if (!this._categories) {
          return this.productsService.categories.pipe(
            tap(categories => this._categories = categories),
          );
        }
        return of(true);
      }),
      map(_ => this._categories),
    );
  }

  // get serviceFeeProduct(): Observable<Product> {
  //   return this._getProducts(OrderLineType.Fee)
  //     .pipe(map(
  //       (products: Product[]) => {
  //         if (products && products.length !== 0) {
  //           return products[0];
  //         }

  //         return null;
  //       }
  //     ));
  // }

  getAdditionalProducts(productIds?: number[]): Observable<Product[]> {
    return this._getSortedProducts(OrderLineType.AdditionalProduct, productIds);
  }

  getAutomaticAdditionalProducts(productIds?: number[]): Observable<Product[]> {
    return this._getSortedProducts(OrderLineType.AutomaticAdditionalProduct, productIds);
  }

  private _getSortedProducts(productsTypes: OrderLineType, productIds?: number[]): Observable<Product[]> {
    return this._getProducts(productsTypes)
      .pipe(map(
        (products: Product[]) => {
          if (products && products.length !== 0) {
            if (productIds != null && productIds.length !== 0) {
              const sorted_products = [];
              for (let i = 0; i < productIds.length; i++) {
                for (let y = 0; y < products.length; y++) {
                  if (products[y].id === productIds[i]) {
                    sorted_products.push(products[y]);
                    break;
                  }
                }
              }
              return sorted_products;
            }
            return products;
          }
          return null;
        }
      ));
  }

  private _getProducts(productsTypes: OrderLineType): Observable<Product[]> {
    return of(true).pipe(
      switchMap(_ => {
        if (!this._allProducts) {
          return this.productsService.allProducts.pipe(
            tap(allProducts => this._fillProductCache(allProducts)),
          );
        }
        return of(true);
      }),
      map(_ => this._allProducts.get(productsTypes)),
    );
  }

  private _fillProductCache(productGroups: ProductGroup[]): void {
    this._allProducts = new Map<OrderLineType, Product[]>();
    if (!productGroups) {
      return;
    }

    productGroups.forEach(
      (productGroup: ProductGroup) => {
        this._allProducts.set(productGroup.groupType, productGroup.products);
      }
    );
  }
}
